module.exports = __webpack_public_path__ + "img/speaker.6ca3a3a9.png";